"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Candlesticks = exports.Candlestick = void 0;
class Candlestick {
    constructor(candlestick) {
        this.date = new Date();
        this.open = 0;
        this.high = 0;
        this.low = 0;
        this.close = 0;
        this.volume = 0;
        if (!candlestick) {
            return;
        }
        this.date = candlestick.date || this.date;
        this.open = candlestick.open || this.open;
        this.high = candlestick.high || this.high;
        this.low = candlestick.low || this.low;
        this.close = candlestick.close || this.close;
        this.volume = candlestick.volume || this.volume;
    }
}
exports.Candlestick = Candlestick;
class Candlesticks {
    constructor() {
        this.list = {};
        this.period = '30m';
    }
}
exports.Candlesticks = Candlesticks;
//# sourceMappingURL=candlestick.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/exchange-common/models/candlestick.js
// module id = 188
// module chunks = 0